import { render, staticRenderFns } from "./active.vue?vue&type=template&id=556e3f7c&scoped=true"
import script from "./active.vue?vue&type=script&lang=js"
export * from "./active.vue?vue&type=script&lang=js"
import style0 from "./active.vue?vue&type=style&index=0&id=556e3f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e3f7c",
  null
  
)

export default component.exports